import DebouncedInput from "@/components/DebouncedInput";
import { Card, Text } from "@chakra-ui/react";
import { Dispatch, SetStateAction, useCallback } from "react";
import { ClaimFilters } from "../types";

type Props = {
  queryFilters: ClaimFilters;
  setQueryFilters: Dispatch<SetStateAction<ClaimFilters>>;
};

const Filters = ({ queryFilters, setQueryFilters }: Props): JSX.Element => {
  const handleSearchByDocument = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({ ...prev, tenantDocumentNumber: value })),
    [setQueryFilters]
  );

  return (
    <Card.Root
      borderRadius="lg"
      border="none"
      flexShrink={0}
      boxShadow="rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
    >
      <Card.Body p="4" gap={3}>
        <Text fontWeight={600}>Buscar</Text>
        <DebouncedInput
          placeholder="Documento del inquilino"
          value={queryFilters.tenantDocumentNumber}
          onDebouncedChange={handleSearchByDocument}
        />
      </Card.Body>
    </Card.Root>
  );
};

export default Filters;
